import React, { FC, useState } from 'react';
import { ExclamationCircleIcon, ExclamationIcon } from '@heroicons/react/outline';
import create from 'zustand';
import { useModalSaving } from 'hooks/useModalSaving';

// components
import Modal from 'components/Modal';
import Button from 'components/Button';
import Stack from 'components/Stack';
import clsx from 'clsx';

const variants: any = {
  error: 'text-red-500',
  success: 'text-green-500',
  warning: 'text-yellow-500'
};

const ConfirmDialog: FC = () => {
  const { title, message, onSubmit, close, open, variant = 'error' } = useConfirmDialogStore();
  const { setIsSaving } = useModalSaving();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDelete = async () => {
    setIsLoading(true);
    setIsSaving(false);
    try {
      await onSubmit(true);
      setIsLoading(false);
      setIsSaving(false);
      close();
    } catch (err) {
      setIsLoading(false);
      setIsSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={close}
      // title="Cancel"
      // subtitle="Scheduled Time"
      classNameTitle="bg-white text-[#29251f] font-Sohne-Regular"
      isConfirmOpen
      size="xl"
    >
      <div className="py-2">
        <div className="font-Sohne-Regular text-xl mb-4">{title}</div>
        <div className="bg-[#f0f0ee] h-[200px] p-5 rounded-md flex items-center flex-col justify-center">
        <div className="flex justify-center">
          {variant === 'warning' ? (
            <ExclamationIcon className={clsx('h-24 w-24', variants[variant])} />
          ) : (
            <ExclamationCircleIcon className={clsx('h-24 w-24', variants[variant])} />
          )}
        </div>
        <div className="text-center text-sm font-Sohne-Regular mt-5">{message}</div>
</div>
        <Stack spacingX={3} className="justify-center mt-5">
          <Button
            variant="hazel-btn-yellow-100"
            rounded="full"
            classNameButton="px-6 py-2 !text-sm font-Sohne-Semibold"
            isLoading={isLoading}
            disabled={isLoading}
            onClick={() => handleDelete()}
          >
            Confirm
          </Button>
          <Button
            variant="invisible"
            rounded="full"
            className="bg-[#E1E6DE]"
            classNameButton="!px-6 !py-2 !text-sm font-Sohne-Semibold bg-hazel-light-gray-200/40 text-white hover:text-hazel-light-gray-200"
            disabled={isLoading}
            onClick={close}
          >
            Cancel
          </Button>
        </Stack>
        
      </div>
    </Modal>
  );
};

interface IConfirm {
  title: string;
  message: string;
  variant?: 'error' | 'success' | 'warning';
  onSubmit: (x: boolean) => Promise<any> | void;
}

const useConfirmDialogStore = create<IConfirm & { close: () => void; open: boolean }>((set) => ({
  title: '',
  message: '',
  open: false,
  variant: 'error',
  onSubmit: (open: boolean) => set({ open }),
  close: () => set({ open: false })
}));

export const confirmDialog = ({ title, message, variant = 'error', onSubmit }: IConfirm) => {
  useConfirmDialogStore.setState({
    title,
    open: true,
    variant,
    message,
    onSubmit
  });
};

export default ConfirmDialog;
